module.exports = __webpack_public_path__ + "img/5.e3d83e6f.svg";